import { createReducer } from '@reduxjs/toolkit';

import deleteWarehouse from '../../../thunks/coilovers/warehouse/deleteWarehouse';
import { clearDeleteWarehouseParts } from '../../../actions/coilovers/warehouse/patchWarehouse';

const initialState = {
  loading: false,
  error: null,
  id: false,
};

const deleteWarehouseReducer = createReducer(initialState, {
  [deleteWarehouse.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [deleteWarehouse.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    id: payload,
  }),
  [deleteWarehouse.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearDeleteWarehouseParts]: () => initialState
});

export default deleteWarehouseReducer;
